import React from 'react';

const SvgJo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="JO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="JO_svg__b" fill="#fff">
        <use xlinkHref="#JO_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#199E56" mask="url(#JO_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#262626" mask="url(#JO_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#E6223A" mask="url(#JO_svg__b)" d="M0 0l13.333 10L0 20z" />
      <path
        fill="#FFF"
        mask="url(#JO_svg__b)"
        d="M4.667 11l-.868.802.086-1.179-1.168-.178.975-.668-.589-1.024 1.13.346L4.667 8 5.1 9.099l1.13-.346-.59 1.024.976.668-1.169.178.086 1.179z"
      />
    </g>
  </svg>
);

export default SvgJo;
